$(function(){
// This legacy sizing integration is storefront-only. It binds global product
// handlers and external requests that are unnecessary inside Shopify's editor
// and can prevent the editor from completing a product-template change.
if(window.Shopify && Shopify.designMode){ return; }
var app_url_feet = "https://advancedbarefoot.com/biopods/",
shop_url_feet = Shopify.shop;
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(t){"use strict";var e=t.fn.jquery.split(" ")[0].split(".");if(e[0]<2&&e[1]<9||1==e[0]&&9==e[1]&&e[2]<1||e[0]>3)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(jQuery),+function(t){"use strict";function e(e,o){return this.each(function(){var s=t(this),n=s.data("bs.bmodal"),a=t.extend({},i.DEFAULTS,s.data(),"object"==typeof e&&e);n||s.data("bs.bmodal",n=new i(this,a)),"string"==typeof e?n[e](o):a.show&&n.show(o)})}var i=function(e,i){this.options=i,this.$body=t(document.body),this.$element=t(e),this.$dialog=this.$element.find(".bmodal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.fixedContent=".navbar-fixed-top, .navbar-fixed-bottom",this.options.remote&&this.$element.find(".bmodal-content").load(this.options.remote,t.proxy(function(){this.$element.trigger("loaded.bs.bmodal")},this))};i.VERSION="3.4.1",i.TRANSITION_DURATION=300,i.BACKDROP_TRANSITION_DURATION=150,i.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},i.prototype.toggle=function(t){return this.isShown?this.hide():this.show(t)},i.prototype.show=function(e){var o=this,s=t.Event("show.bs.bmodal",{relatedTarget:e});this.$element.trigger(s),this.isShown||s.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("bmodal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.bmodal",'[data-dismiss="bmodal"]',t.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.bmodal",function(){o.$element.one("mouseup.dismiss.bs.bmodal",function(e){t(e.target).is(o.$element)&&(o.ignoreBackdropClick=!0)})}),this.backdrop(function(){var s=t.support.transition&&o.$element.hasClass("fade");o.$element.parent().length||o.$element.appendTo(o.$body),o.$element.show().scrollTop(0),o.adjustDialog(),s&&o.$element[0].offsetWidth,o.$element.addClass("in"),o.enforceFocus();var n=t.Event("shown.bs.bmodal",{relatedTarget:e});s?o.$dialog.one("bsTransitionEnd",function(){o.$element.trigger("focus").trigger(n)}).emulateTransitionEnd(i.TRANSITION_DURATION):o.$element.trigger("focus").trigger(n)}))},i.prototype.hide=function(e){e&&e.preventDefault(),e=t.Event("hide.bs.bmodal"),this.$element.trigger(e),this.isShown&&!e.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),t(document).off("focusin.bs.bmodal"),this.$element.removeClass("in").off("click.dismiss.bs.bmodal").off("mouseup.dismiss.bs.bmodal"),this.$dialog.off("mousedown.dismiss.bs.bmodal"),t.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",t.proxy(this.hideModal,this)).emulateTransitionEnd(i.TRANSITION_DURATION):this.hideModal())},i.prototype.enforceFocus=function(){t(document).off("focusin.bs.bmodal").on("focusin.bs.bmodal",t.proxy(function(t){document===t.target||this.$element[0]===t.target||this.$element.has(t.target).length||this.$element.trigger("focus")},this))},i.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.bmodal",t.proxy(function(t){27==t.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.bmodal")},i.prototype.resize=function(){this.isShown?t(window).on("resize.bs.bmodal",t.proxy(this.handleUpdate,this)):t(window).off("resize.bs.bmodal")},i.prototype.hideModal=function(){var t=this;this.$element.hide(),this.backdrop(function(){t.$body.removeClass("bmodal-open"),t.resetAdjustments(),t.resetScrollbar(),t.$element.trigger("hidden.bs.bmodal")})},i.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},i.prototype.backdrop=function(e){var o=this,s=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var n=t.support.transition&&s;if(this.$backdrop=t(document.createElement("div")).addClass("bmodal-backdrop "+s).appendTo(this.$body),this.$element.on("click.dismiss.bs.bmodal",t.proxy(function(t){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(t.target===t.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),n&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!e)return;n?this.$backdrop.one("bsTransitionEnd",e).emulateTransitionEnd(i.BACKDROP_TRANSITION_DURATION):e()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var a=function(){o.removeBackdrop(),e&&e()};t.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",a).emulateTransitionEnd(i.BACKDROP_TRANSITION_DURATION):a()}else e&&e()},i.prototype.handleUpdate=function(){this.adjustDialog()},i.prototype.adjustDialog=function(){var t=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&t?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!t?this.scrollbarWidth:""})},i.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},i.prototype.checkScrollbar=function(){var t=window.innerWidth;if(!t){var e=document.documentElement.getBoundingClientRect();t=e.right-Math.abs(e.left)}this.bodyIsOverflowing=document.body.clientWidth<t,this.scrollbarWidth=this.measureScrollbar()},i.prototype.setScrollbar=function(){var e=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"";var i=this.scrollbarWidth;this.bodyIsOverflowing&&(this.$body.css("padding-right",e+i),t(this.fixedContent).each(function(e,o){var s=o.style.paddingRight,n=t(o).css("padding-right");t(o).data("padding-right",s).css("padding-right",parseFloat(n)+i+"px")}))},i.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad),t(this.fixedContent).each(function(e,i){var o=t(i).data("padding-right");t(i).removeData("padding-right"),i.style.paddingRight=o?o:""})},i.prototype.measureScrollbar=function(){var t=document.createElement("div");t.className="bmodal-scrollbar-measure",this.$body.append(t);var e=t.offsetWidth-t.clientWidth;return this.$body[0].removeChild(t),e};var o=t.fn.bmodal;t.fn.bmodal=e,t.fn.bmodal.Constructor=i,t.fn.bmodal.noConflict=function(){return t.fn.bmodal=o,this},t(document).on("click.bs.bmodal.data-api",'[data-toggle="bmodal"]',function(i){var o=t(this),s=o.attr("href"),n=o.attr("data-target")||s&&s.replace(/.*(?=#[^\s]+$)/,""),a=t(document).find(n),r=a.data("bs.bmodal")?"toggle":t.extend({remote:!/#/.test(s)&&s},a.data(),o.data());o.is("a")&&i.preventDefault(),a.one("show.bs.bmodal",function(t){t.isDefaultPrevented()||a.one("hidden.bs.bmodal",function(){o.is(":visible")&&o.trigger("focus")})}),e.call(a,r,this)})}(jQuery);
//if($('#foot_mlist').length){
var confirmstatus=0;
var addfmstatus=true;
var addnewsize=false;
var creategafCookie = function(name, value, days){
    if (days) {
        var expiry = new Date();
        expiry.setTime(expiry.getTime()+(days*24*60*60*1000));
        var expires = "; expires=" + expiry.toGMTString();
    } else {
        var expires = "";
    }
    document.cookie = escape(name) + "=" + escape(value) + expires + "; path=/";
}
var readgafCookie = function(name){
    var nameEQ = escape(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ')
        c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0)
        return unescape(c.substring(nameEQ.length, c.length));
    }
    return null;
}
var BIOPODS_CODE_SIZE_LOOKUP = {"C3/L4 - N1":{"child":null,"men":null,"width":"Narrow Width","women":"4"},"C3/L4 - N1.5":{"child":"2.5","men":null,"width":"Narrow Width","women":"4.5"},"C3/L4 - N2":{"child":"3","men":null,"width":"Narrow Width","women":null},"C3/L4 - R1":{"child":null,"men":null,"width":"Standard Width","women":"4"},"C3/L4 - R1.5":{"child":"2.5","men":null,"width":"Standard Width","women":"4.5"},"C3/L4 - R2":{"child":"3","men":null,"width":"Standard Width","women":null},"C3/L4 - W2":{"child":"2.5","men":null,"width":"Wide Width","women":"4"},"C3/L4 - W2.5":{"child":"3","men":null,"width":"Wide Width","women":"4.5"},"C4/L5 - N1":{"child":null,"men":null,"width":"Narrow Width","women":"5"},"C4/L5 - N1.5":{"child":"3.5","men":null,"width":"Narrow Width","women":"5.5"},"C4/L5 - N2":{"child":"4","men":null,"width":"Narrow Width","women":null},"C4/L5 - R1":{"child":null,"men":null,"width":"Standard Width","women":"5"},"C4/L5 - R1.5":{"child":"3.5","men":null,"width":"Standard Width","women":"5.5"},"C4/L5 - R2":{"child":"4","men":null,"width":"Standard Width","women":null},"C4/L5 - W2":{"child":"3.5","men":null,"width":"Wide Width","women":"5"},"C4/L5 - W2.5":{"child":"4","men":null,"width":"Wide Width","women":"5.5"},"C5/L6 - N1":{"child":null,"men":null,"width":"Narrow Width","women":"6"},"C5/L6 - N1.5":{"child":"4.5","men":null,"width":"Narrow Width","women":"6.5"},"C5/L6 - N2":{"child":"5","men":null,"width":"Narrow Width","women":null},"C5/L6 - R1":{"child":null,"men":null,"width":"Standard Width","women":"6"},"C5/L6 - R1.5":{"child":"4.5","men":null,"width":"Standard Width","women":"6.5"},"C5/L6 - R2":{"child":"5","men":null,"width":"Standard Width","women":null},"C5/L6 - W2":{"child":"4.5","men":null,"width":"Wide Width","women":"6"},"C5/L6 - W2.5":{"child":"5","men":null,"width":"Wide Width","women":"6.5"},"M10/L11 - N1":{"child":null,"men":null,"width":"Narrow Width","women":"11"},"M10/L11 - N1.5":{"child":null,"men":"9.5","width":"Narrow Width","women":"11.5"},"M10/L11 - N2":{"child":null,"men":"10","width":"Narrow Width","women":null},"M10/L11 - R1":{"child":null,"men":null,"width":"Standard Width","women":"11"},"M10/L11 - R1.5":{"child":null,"men":"9.5","width":"Standard Width","women":"11.5"},"M10/L11 - R2":{"child":null,"men":"10","width":"Standard Width","women":null},"M10/L11 - W2":{"child":null,"men":"9.5","width":"Wide Width","women":"11"},"M10/L11 - W2.5":{"child":null,"men":"10","width":"Wide Width","women":"11.5"},"M11/L12 - N1":{"child":null,"men":null,"width":"Narrow Width","women":"12"},"M11/L12 - N1.5":{"child":null,"men":"10.5","width":"Narrow Width","women":"12.5"},"M11/L12 - N2":{"child":null,"men":"11","width":"Narrow Width","women":null},"M11/L12 - R1":{"child":null,"men":null,"width":"Standard Width","women":"12"},"M11/L12 - R1.5":{"child":null,"men":"10.5","width":"Standard Width","women":"12.5"},"M11/L12 - R2":{"child":null,"men":"11","width":"Standard Width","women":null},"M11/L12 - W2":{"child":null,"men":"10.5","width":"Wide Width","women":"12"},"M11/L12 - W2.5":{"child":null,"men":"11","width":"Wide Width","women":"12.5"},"M12 - N1.5":{"child":null,"men":"11.5","width":"Narrow Width","women":null},"M12 - N2":{"child":null,"men":"12","width":"Narrow Width","women":null},"M12 - R1.5":{"child":null,"men":"11.5","width":"Standard Width","women":null},"M12 - R2":{"child":null,"men":"12","width":"Standard Width","women":null},"M12 - W2":{"child":null,"men":"11.5","width":"Wide Width","women":null},"M12 - W2.5":{"child":null,"men":"12","width":"Wide Width","women":null},"M13 - N1.5":{"child":null,"men":"12.5","width":"Narrow Width","women":null},"M13 - N2":{"child":null,"men":"13","width":"Narrow Width","women":null},"M13 - R1.5":{"child":null,"men":"12.5","width":"Standard Width","women":null},"M13 - R2":{"child":null,"men":"13","width":"Standard Width","women":null},"M13 - W2":{"child":null,"men":"12.5","width":"Wide Width","women":null},"M13 - W2.5":{"child":null,"men":"13","width":"Wide Width","women":null},"M14 - N1.5":{"child":null,"men":"13.5","width":"Narrow Width","women":null},"M14 - N2":{"child":null,"men":"14","width":"Narrow Width","women":null},"M14 - R1.5":{"child":null,"men":"13.5","width":"Standard Width","women":null},"M14 - R2":{"child":null,"men":"14","width":"Standard Width","women":null},"M14 - W2":{"child":null,"men":"13.5","width":"Wide Width","women":null},"M14 - W2.5":{"child":null,"men":"14","width":"Wide Width","women":null},"M15 - N1.5":{"child":null,"men":"14.5","width":"Narrow Width","women":null},"M15 - N2":{"child":null,"men":"15","width":"Narrow Width","women":null},"M15 - R1.5":{"child":null,"men":"14.5","width":"Standard Width","women":null},"M15 - R2":{"child":null,"men":"15","width":"Standard Width","women":null},"M15 - W2":{"child":null,"men":"14.5","width":"Wide Width","women":null},"M15 - W2.5":{"child":null,"men":"15","width":"Wide Width","women":null},"M16 - N1.5":{"child":null,"men":"15.5","width":"Narrow Width","women":null},"M16 - N2":{"child":null,"men":"16","width":"Narrow Width","women":null},"M16 - R1.5":{"child":null,"men":"15.5","width":"Standard Width","women":null},"M16 - R2":{"child":null,"men":"16","width":"Standard Width","women":null},"M16 - W2":{"child":null,"men":"15.5","width":"Wide Width","women":null},"M16 - W2.5":{"child":null,"men":"16","width":"Wide Width","women":null},"M6/L7 - N1":{"child":null,"men":null,"width":"Narrow Width","women":"7"},"M6/L7 - N1.5":{"child":null,"men":"5.5","width":"Narrow Width","women":"7.5"},"M6/L7 - N2":{"child":null,"men":"6","width":"Narrow Width","women":null},"M6/L7 - R1":{"child":null,"men":null,"width":"Standard Width","women":"7"},"M6/L7 - R1.5":{"child":null,"men":"5.5","width":"Standard Width","women":"7.5"},"M6/L7 - R2":{"child":null,"men":"6","width":"Standard Width","women":null},"M6/L7 - W2":{"child":null,"men":"5.5","width":"Wide Width","women":"7"},"M6/L7 - W2.5":{"child":null,"men":"6","width":"Wide Width","women":"7.5"},"M7/L8 - N1":{"child":null,"men":null,"width":"Narrow Width","women":"8"},"M7/L8 - N1.5":{"child":null,"men":"6.5","width":"Narrow Width","women":"8.5"},"M7/L8 - N2":{"child":null,"men":"7","width":"Narrow Width","women":null},"M7/L8 - R1":{"child":null,"men":null,"width":"Standard Width","women":"8"},"M7/L8 - R1.5":{"child":null,"men":"6.5","width":"Standard Width","women":"8.5"},"M7/L8 - R2":{"child":null,"men":"7","width":"Standard Width","women":null},"M7/L8 - W2":{"child":null,"men":"6.5","width":"Wide Width","women":"8"},"M7/L8 - W2.5":{"child":null,"men":"7","width":"Wide Width","women":"8.5"},"M8/L9 - N1":{"child":null,"men":null,"width":"Narrow Width","women":"9"},"M8/L9 - N1.5":{"child":null,"men":"7.5","width":"Narrow Width","women":"9.5"},"M8/L9 - N2":{"child":null,"men":"8","width":"Narrow Width","women":null},"M8/L9 - R1":{"child":null,"men":null,"width":"Standard Width","women":"9"},"M8/L9 - R1.5":{"child":null,"men":"7.5","width":"Standard Width","women":"9.5"},"M8/L9 - R2":{"child":null,"men":"8","width":"Standard Width","women":null},"M8/L9 - W2":{"child":null,"men":"7.5","width":"Wide Width","women":"9"},"M8/L9 - W2.5":{"child":null,"men":"8","width":"Wide Width","women":"9.5"},"M9/L10 - N1":{"child":null,"men":null,"width":"Narrow Width","women":"10"},"M9/L10 - N1.5":{"child":null,"men":"8.5","width":"Narrow Width","women":"10.5"},"M9/L10 - N2":{"child":null,"men":"9","width":"Narrow Width","women":null},"M9/L10 - R1":{"child":null,"men":null,"width":"Standard Width","women":"10"},"M9/L10 - R1.5":{"child":null,"men":"8.5","width":"Standard Width","women":"10.5"},"M9/L10 - R2":{"child":null,"men":"9","width":"Standard Width","women":null},"M9/L10 - W2":{"child":null,"men":"8.5","width":"Wide Width","women":"10"},"M9/L10 - W2.5":{"child":null,"men":"9","width":"Wide Width","women":"10.5"}};
function normalizeBiopodsCode(code){
    if(!code){
        return "";
    }
    return String(code)
        .replace(/\u00a0/g, " ")
        .replace(/\s+/g, " ")
        .replace(/\s*\/\s*/g, "/")
        .replace(/\s*-\s*/g, " - ")
        .trim();
}
function getBiopodsSizeDetails(code){
    var normalized = normalizeBiopodsCode(code);
    if(normalized === ""){
        return null;
    }
    return BIOPODS_CODE_SIZE_LOOKUP[normalized] || null;
}
function getBiopodsShoeSizeInfo(code, gender){
    var details = getBiopodsSizeDetails(code);
    var labels = [];
    var normalizedGender = String(gender || "").toLowerCase();
    if(!details){
        return {
            label: "",
            note: ""
        };
    }
    if(normalizedGender === "child" || normalizedGender === "children"){
        if(details.child){
            return {
                label: "US Children's " + details.child,
                note: ""
            };
        }
        return {
            label: "Please email us for sizing assistance",
            note: "We could not match these measurements to a direct children's size. Please email orders@biopods.com for assistance."
        };
    }
    if(normalizedGender === "woman" || normalizedGender === "women"){
        if(details.women){
            return {
                label: "US Women's " + details.women,
                note: ""
            };
        }
        if(details.men){
            return {
                label: "US Men's " + details.men,
                note: "Your foot volume is greater than our standard Women's sizing. Our unisex Men's size will fit you best."
            };
        }
        return {
            label: "Please email us for sizing assistance",
            note: "We could not match these measurements to a direct women's size. Please email orders@biopods.com for assistance."
        };
    }
    if(normalizedGender === "man" || normalizedGender === "men"){
        if(details.men){
            return {
                label: "US Men's " + details.men,
                note: ""
            };
        }
        if(details.women){
            return {
                label: "US Women's " + details.women,
                note: "Men's sizes are not available for this fit. The size shown above is the closest women's equivalent."
            };
        }
        return {
            label: "Please email us for sizing assistance",
            note: "We could not match these measurements to a direct men's size. Please email orders@biopods.com for assistance."
        };
    }
    if(details.child){
        labels.push("US Children's " + details.child);
    }
    if(details.women){
        labels.push("US Women's " + details.women);
    }
    if(details.men){
        labels.push("US Men's " + details.men);
    }
    return {
        label: labels.join(" / "),
        note: ""
    };
}
function getBiopodsShoeSizeLabel(code, gender){
    return getBiopodsShoeSizeInfo(code, gender).label;
}
function getBiopodsShoeSizeNote(code, gender){
    return getBiopodsShoeSizeInfo(code, gender).note;
}
function getBiopodsWidthLabel(code){
    var details = getBiopodsSizeDetails(code);
    if(!details || !details.width){
        return "";
    }
    return details.width;
}
function getPublicMeasurementEmailWorkerUrl(){
    var $pageForm = $('#addfm.foot-measurement-page');
    if(!$pageForm.length){
        return "";
    }
    return String($pageForm.attr('data-email-worker-url') || "").trim();
}
function getFootMeasurementEmailPayload(code, gender){
    var details = getBiopodsSizeDetails(code) || {};
    var $form = $('#addfm form').first();
    return {
        name: String($form.find("[name='name']").val() || "").trim(),
        email: String($form.find("[name='email']").val() || "").trim(),
        gender: String(gender || ""),
        unit: String($form.find("[name='unit']:checked").val() || ""),
        leftFoot: {
            length: String($form.find("[name='lf[length]']").val() || ""),
            width: String($form.find("[name='lf[width]']").val() || ""),
            volume: String($form.find("[name='lf[volume]']").val() || "")
        },
        rightFoot: {
            length: String($form.find("[name='Rf[length]']").val() || ""),
            width: String($form.find("[name='Rf[width]']").val() || ""),
            volume: String($form.find("[name='Rf[volume]']").val() || "")
        },
        recommendation: {
            shoeSize: getBiopodsShoeSizeLabel(code, gender),
            note: getBiopodsShoeSizeNote(code, gender),
            width: details.width || "",
            skuCode: normalizeBiopodsCode(code)
        }
    };
}
function sendFootMeasurementRecommendationEmail(payload){
    var workerUrl = getPublicMeasurementEmailWorkerUrl();
    if(workerUrl === "" || payload.email === ""){
        return;
    }
    $.ajax({
        type: 'POST',
        url: workerUrl,
        data: JSON.stringify(payload),
        contentType: 'application/json',
        dataType: 'json'
    }).done(function(){
        $('#addfm .form-notifications-container').html("<div class='success'>We also emailed these results to you.</div>");
    }).fail(function(){
        $('#addfm .form-notifications-container').html("<div class='error'>Your results were shown on page, but the email could not be sent.</div>");
    });
}
function setMatchedShoeSizeFields(value){
    var hasValue = value !== "";
    $('#ss_size_code').val(value);
    $('.matched-shoe-size-display').val(value);
    if(hasValue){
        $('.matched-shoe-size-row').show();
    }else{
        $('.matched-shoe-size-row').hide();
    }
}
function clearFootMeasurementSize(){
    $('#addfm .shoe-size').text("");
    $('#addfm .shoe-width').text("");
    $('#addfm .shoe-note').text("").hide();
}
function setFootMeasurementSize(code, gender){
    $('#addfm .shoe-size').text(getBiopodsShoeSizeLabel(code, gender));
    $('#addfm .shoe-width').text(getBiopodsWidthLabel(code));
    var note = getBiopodsShoeSizeNote(code, gender);
    if(note !== ""){
        $('#addfm .shoe-note').text(note).show();
    }else{
        $('#addfm .shoe-note').text("").hide();
    }
}
function getSelectedStandardShoeSizeLabel(){
    var gender = $("[name='std_gender']:checked").val();
    var size = $("[name='std_size']:checked").val();
    if(!gender || !size){
        return "";
    }
    if(gender === "man"){
        return "US Men's " + size;
    }
    if(gender === "woman"){
        return "US Women's " + size;
    }
    if(gender === "child"){
        return "US Children's " + size;
    }
    return "";
}

function display_unit_desc( unit = false ){
    $( '.units-desc > *' ).css( 'display', 'none' );
    if( !unit ){
        unit = $( 'input[name="unit"]:checked' ).val();
    }
    $( '.' + unit + '-desc' ).css( 'display', 'block' );
}
	display_unit_desc();
	$( 'input[name="unit"]' ).on( 'change', function(){
		display_unit_desc();
	});
  $('body').on( 'submit','#addfm form', function(e){

    var $_form = $(this);
    var generatedGender = $_form.find("[name='gender']:checked").val();
        e.preventDefault();
        $('#addfm').append('<div class="wait"></div>');
    $( '.form-notifications-container' ).html('');
        var formdata = $_form.serialize();
            $.ajax({
              type: 'POST',
              url: app_url_feet + "shoe_cals",
              data: formdata,
              dataType: "json",
              success: function (data) {
                var error_message='';
                   error_message = "Your measurements are outside of our standard size range. Please email <a href='mailto:orders@biopods.com'>orders@biopods.com</a> for assistance, or <span class='out-of-range-size-popup-btn'>click here</span> for more information.";
                $('.wait').remove();
                if(data.existname)
                {
                  $( '.form-notifications-container' ).html( "<div class='error'>This name already exists.</div>" );
                  return;
                }
			    if( data.success ){
					if( data.sku_data ){
						if( data.sku_data.size_found ){
                        var isPublicFootMeasurementPage = $('#addfm').hasClass('foot-measurement-page');
                        if($('#shoes_pp').length){
                            if($('.cart-size').attr('data-cid')==''){
                              if(readgafCookie('bio-custom-size_id')!=''){
                                var sids=readgafCookie('bio-custom-size_id')+','+data.sku_data.size_id;
                                creategafCookie('bio-custom-size_id',sids, 1);
                              }else{
                                creategafCookie('bio-custom-size_id',data.sku_data.size_id, 1);
                              }
                              $('.cart-size').attr('data-size_id',readgafCookie('bio-custom-size_id'));
                            }
                            if(typeof get_foot_option_cart === 'function'){
                              get_foot_option_cart();
                            }
                            addnewsize=true;
                          }else if($('#button--7fb576f3-53e6-4e46-a9c2-d753a6a1e72f').length || isPublicFootMeasurementPage){
                            var displaySku = normalizeBiopodsCode(data.sku_data.sku);
                            var emailPayload = isPublicFootMeasurementPage ? getFootMeasurementEmailPayload(displaySku, generatedGender) : null;
                            $('.size-code').html(displaySku);
                            setFootMeasurementSize(displaySku, generatedGender);
								$('.size-code-content-container').css({'opacity': 1,'visibility': 'visible'});
                              clear_form();
                              if(isPublicFootMeasurementPage && emailPayload){
                                sendFootMeasurementRecommendationEmail(emailPayload);
                              }
                          }else{
							var displaySku = normalizeBiopodsCode(data.sku_data.sku);
							$('.size-code').html(displaySku);
                            setFootMeasurementSize(displaySku, generatedGender);
							$('.size-code-content-container').css({'opacity': 1,'visibility': 'visible'});
                              clear_form();
                             get_foot_list();

                          setTimeout(function(){
                            if(addfmstatus){
                                if($('.fmrow').length==1){
                                  confirmstatus=1;
                                  $('#confirm_mes').html('Are any of the items in your order for anybody other than yourself?');
                                  $('#addfm').bmodal('hide');
                                  $('#confirm').bmodal('show');
                                }else{
                                  	confirmstatus=2;
                                    $('#confirm_mes').html('Do you have more people to add measurements for?');
                                    $('#addfm').bmodal('hide');
                                    $('#confirm').bmodal('show');
                                }
                            }else{
                              addfmstatus=true;
                            }

                          $('.wait').remove();
                          }, 2000);
                          }
						}else{
							$( '.form-notifications-container' ).html( "<div class='error'>" + error_message + "</div>" );
						}
					}
				}else{
					$( '.form-notifications-container' ).html( "<div class='error'>" + error_message + "</div>" );
				}

              },
              });
     });
 $("#addfm").on("hidden.bs.bmodal", function () {
    $('.size-code').html('');
	$('.size-code-content-container').css({'opacity': 0,'visibility': 'hidden'});
    clearFootMeasurementSize();
    clear_form();
});
 $("#assignfm").on("hidden.bs.bmodal", function () {
    $('.assign_message').html('');
});

 $('body').on( 'click','#fmebtn', function(e){
  if($(this).text()!='Edit'){
   }
   addfmstatus=false;

   var fmdata=$(this).attr('data-fm');
   fmdata = JSON.parse(fmdata);
   clear_form();

    $("[name='np_status']").val(fmdata.np_status);
   $("[name='name']").val(fmdata.name);
   $("[name='foot_id']").val(fmdata.id);
   $("[name='gender'][value='" + fmdata.gender + "']").prop('checked', true);
   $("[name='unit'][value='" + fmdata.unit + "']").prop('checked', true);
   if(fmdata.unit=='inches')
   {
      $("[name='lf[length]']").val(fmdata.ileftfoot_legth);
      $("[name='lf[width]']").val(fmdata.ileftfoot_width);
      $("[name='lf[volume]']").val(fmdata.ileftfoot_girth);
      $("[name='Rf[length]']").val(fmdata.irightfoot_legth);
      $("[name='Rf[width]']").val(fmdata.irightfoot_width);
      $("[name='Rf[volume]']").val(fmdata.irightfoot_girth);
   }else{
      $("[name='lf[length]']").val(fmdata.leftfoot_legth);
      $("[name='lf[width]']").val(fmdata.leftfoot_width);
      $("[name='lf[volume]']").val(fmdata.leftfoot_girth);
      $("[name='Rf[length]']").val(fmdata.rightfoot_legth);
      $("[name='Rf[width]']").val(fmdata.rightfoot_width);
      $("[name='Rf[volume]']").val(fmdata.rightfoot_girth);
   }
    $("[name='lf[arch-height]'][value='" + fmdata.leftfoot_ah + "']").prop('checked', true);
    $("[name='Rf[arch-height]'][value='" + fmdata.rightfoot_ah + "']").prop('checked', true);
   $('#addfm').bmodal('show');
 });
 $('body').on( 'click','#fmdbtn', function(e){
     var id=$(this).attr('data-id');
     $('body').append('<div class="wait"></div>');
       $.ajax({
              type: 'POST',
              url: app_url_feet + "shoe_cals/delete_foot_list",
              data: {
                id:id,
              },
              success: function (data) {
                 get_foot_list();
                $('.wait').remove();
              },
              });
   });
  function clear_form(){
     $("[name='name']").val('');
     $("[name='foot_id']").val('');
     $("[name='gender']").prop('checked', false);
     $("[name='unit']").prop('checked', false);

     $("[name='lf[length]']").val('');
     $("[name='lf[width]']").val('');
     $("[name='lf[volume]']").val('');
     $("[name='lf[arch-height]']").prop('checked', false);

     $("[name='Rf[length]']").val('');
     $("[name='Rf[width]']").val('');
     $("[name='Rf[volume]']").val('');
     $("[name='Rf[arch-height]']").prop('checked', false);
     $( '.form-notifications-container' ).html('');
  }
get_foot_list();
  function get_foot_list(){
    var   cust_id=$('#foot_mlist').attr('data-cid');
       $.ajax({
            type: 'POST',
            url: app_url_feet + "shoe_cals/get_foot_list",
            data: {
              cust_id:cust_id,
            },
            success: function (data) {
               $('#foot_mlist').html(data);
            },
            });
         $.ajax({
            type: 'POST',
            url: app_url_feet + "shoe_cals/get_foot_option",
            data: {
              cust_id:cust_id,
            },
            success: function (data) {
               $('#size_code').html(data);
            },
            });
  }
  $('body').on('change','#order_id', function(e){
         var order_id=$(this).val();
         $('.poption').hide();
         $('.po_'+order_id).show();
       });
  $('body').on( 'submit','#assignfm form', function(e){

    var $_form = $(this);
        e.preventDefault();
        $('body').append('<div class="wait"></div>');
        var formdata = $_form.serialize();
        var order_name=$( "#order_id option:selected" ).text();
        var sku=$( "#varaint_id option:selected" ).attr('data-sku');
        var product_id=$( "#varaint_id option:selected" ).attr('data-product_id');
        var product_name=$( "#varaint_id option:selected" ).text();
        formdata += '&order_name='+order_name+'&sku='+sku+'&product_id='+product_id+'&product_name='+product_name.trim();
            $.ajax({
              type: 'POST',
              url: app_url_feet + "shoe_cals/assign_order_product",
              data: formdata,
              success: function (data) {
                $('.assign_message').html(data);
              },
              });
     });
  $('body').on( 'click','#confirm_yes', function(e){
    if(confirmstatus==1){
       $('#confirm').bmodal('hide');
       $('#addfm').bmodal('show');
    }else{
      $('#confirm').bmodal('hide');
      $('#addfm').bmodal('show');
    }
 });
  $('body').on( 'click','#confirm_no', function(e){
     if(confirmstatus==1){
       $('#confirm').bmodal('hide');
      $('#assignfm').bmodal('show');
      }else{
        $('#confirm').bmodal('hide');
       location.href='https://'+shop_url_feet+'/pages/orders';
      }
  });

//}
if($('.order_size_code').length){
     var   cust_id=$('.order_size_code').attr('data-cid');
       $.ajax({
            type: 'POST',
            url: app_url_feet + "shoe_cals/get_foot_option",
            data: {
              cust_id:cust_id,
              for:'order',
            },
            success: function (data) {
               $('.order_size_code').html(data);
              $('.order_size_code').each(function() {
                var size=$(this).attr('data-size');
                $(this).find("option[data-size='" +size+ "']").attr("selected","selected");
              });
            },
            });
 $('body').on( 'change','.order_size_code', function(e){
  if($(this).val()=='')
  {
      var size=$(this).attr('data-size');
       $(this).val($(this).find("option[data-size='" +size+ "']").val());
  }else{
          $.ajax({
              type: 'POST',
              url: app_url_feet + "shoe_cals/assign_order_product",
              data: {
                order_id:$(this).attr('data-order_id'),
                varaint_id:$(this).attr('data-varaint_id'),
                line_item_id:$(this).attr('data-line_item_id'),
                sku:$(this).attr('data-sku'),
                size_id:$(this).val(),
              },
              success: function (data) {
                alert('Assign size to ordered product successfully');
              },
              });
  }
});
}

// Keep get_foot_option_cart at outer scope so it is always available,
// regardless of whether .cart-size elements exist at page load time.
function get_foot_option_cart(){
  if(!$('.cart-size').length){ return; }
  $('.cart-size').each(function() {
   var   cust_id=$(this).attr('data-cid');
       $.ajax({
            type: 'POST',
            url: app_url_feet + "shoe_cals/get_foot_option_cart",
            dataType: "json",
            data: {
              cust_id:cust_id,
              id:$(this).attr('id'),
              size_id:$(this).attr('data-size_id'),
              for:'order',
            },
            success: function (data) {
              setTimeout(function() {
              if(data.html!=''){
                $('#'+data.id).html('<option value="" >Select Custom Size Code</option>'+data.html+'<option value="New Size code">+Add New Size code</option>');
                 $('#'+data.id).show();
                if(addnewsize){
                    $('#'+data.id+' option:eq(1)').attr('selected', 'selected');
                   $('#'+data.id).trigger('change');
                   $('#addfm').bmodal('hide');
                   addnewsize=false;
                 }
                 if(readgafCookie('bio-custom-size_id')!=''){
                     $('#'+data.id+' option:eq(1)').attr('selected', 'selected');
                      $('#'+data.id).trigger('change');
                  }
              }else{
                $('#'+data.id).html('<option value="New Size code">+Add New Size code</option>');
                $('#'+data.id).hide();
              }
                 $('.cart-size').each(function() {
                if( typeof $(this).attr('data-sel') !== 'undefined' ){
                  $(this).val($(this).attr('data-sel'));
                }
                   var vid=$(this).attr('data-vid');
                  if($(this).val()=='New Size code'){
                      if($('#shoes_pp').length){
                        if($('#np_now_or_later').length){
                        }
                      }
                    if($("[name='sizes_type']").filter(":checked").val()=='customization' || !$('#shoes_pp').length){
                    $('input#new_profile_'+vid).show();
                    $('input#new_profile_'+vid).prop('required',true);
                 }
                  }else{
                   if($('#shoes_pp').length){
                        if($('#np_now_or_later').length){
                            $('#now').click();
                        }
                    }
                      if($("[name='sizes_type']").filter(":checked").val()=='customization' || !$('#shoes_pp').length){
                          $('input#new_profile_'+vid).hide();
                          $('input#new_profile_'+vid).prop('required',false);
                      }
                  }
              });
              }, 1000);
            },
            });
      });
}

if($('.cart-size').length){
  if(readgafCookie('bio-custom-size_id')!=''){
    $('.cart-size').attr('data-size_id',readgafCookie('bio-custom-size_id'));
  }
get_foot_option_cart();

  $('body').on( 'change','.cart-size', function(e){
    var vid=$(this).attr('data-vid');
    if($(this).val()=='New Size code'){
     if($('#shoes_pp').length){
          if($('#np_now_or_later').length){
            if($("[name='now_or_later']").filter(":checked").val()=='now'){
            $('#add_me_now').click();
            }
            return;
          }
        }
      $('input#new_profile_'+vid).show();
      $('input#new_profile_'+vid).prop('required',true);
      setMatchedShoeSizeFields("");
    }else{
      if($('#shoes_pp').length){
          if($('#np_now_or_later').length){
            $('#now').click();
          }
        }
      $('input#new_profile_'+vid).hide();
      $('input#new_profile_'+vid).val('');
      $('input#new_profile_'+vid).prop('required',false);
      if($(".customization-inputs [name='properties[These shoes are for]']").length)
      {
        $(".customization-inputs [name='properties[These shoes are for]']").val($(this).find('option:selected').attr('data-name'));
        var vid=$(".product__atc [name='id']").val();
        var sku=$('#v_sku').find("option[value='" +vid+ "']").text();
        var size=$(this).find('option:selected').attr('data-size');
        console.log(sku+' - '+size);
        $('#ss_master_sku').val(sku+'-'+size);
        $('#size_id').attr('name',$('#size_id').attr('data-name'));
        $('#size_id').val($(this).find('option:selected').attr('data-id'));
        setMatchedShoeSizeFields(getBiopodsShoeSizeLabel(size));
      }
    }
  });
}
if($('#foot_custid').length){
   var   cust_id=$('#foot_custid').val();
       $.ajax({
            type: 'POST',
            url: app_url_feet + "shoe_cals/check_for_add_profile",
            data: {
              cust_id:cust_id,
            },
            success: function (data) {
              if(data!=''){
                 $('#add_redirect_mes').html(data);
                $('#add_redirect').bmodal('show');
              }
            },
            });
}
 $('body').on( 'click','.out-of-range-size-popup-btn', function(e){
  $('#email_send_modal').bmodal('show');
  });
 $('body').on( 'click','#email_send', function(e){
      var $_form = $('#addfm form');
      var formdata = $_form.serialize();
      $.ajax({
        type: 'POST',
        url: app_url_feet + "shoe_cals/email_send",
        data: formdata,
        success: function (data) {
         alert('Email send successfully.');
          $('#email_send_modal').bmodal('hide');
          $('#addfm').bmodal('hide');
        },
      });
  });
  setTimeout(function() {
size_type();
   }, 50);

$("[name='sizes_type']").on( 'click', function(){
size_type();
});
function size_type()
  {
    $("[name='properties[Sizes Type]']").val($("[name='sizes_type']").filter(":checked").val());
     if($("[name='sizes_type']").filter(":checked").val()=='standard'){
      $('.standard-inputs').show();
      $('.customization-inputs').hide();
       $('.ss-input').each(function() {
         $(this).prop('required',true);
       });
       $('.cc-input').each(function() {
         $(this).prop('required',false);
       });
       $('.std-prop').each(function() {
         $(this).attr('name',$(this).attr('data-name'));
       });
       $('.cust-prop').each(function() {
         $(this).removeAttr('name');
       });
    }else{
      $('.standard-inputs').hide();
      $('.customization-inputs').show();
       $('.ss-input').each(function() {
         $(this).prop('required',false);
       });
        $('.cc-input').each(function() {
         $(this).prop('required',true);
       });
       $('.std-prop').each(function() {
         $(this).removeAttr('name');
       });
       $('.cust-prop').each(function() {
         $(this).attr('name',$(this).attr('data-name'));
       });
       now_or_later_fc();
    }
  }
$("[name='std_gender']").on( 'click', function(){
  var g=$("[name='std_gender']:checked").val();
		$.ajax({
        type: 'POST',
        url: app_url_feet + "shoe_cals/standard_size",
        data:{gender:g},
        success: function (data) {
          $('#size_inputs_btn_box').html(data);
          $('.sizechart').removeClass('sizechart--active').hide();
          $('#'+g+'_chart').addClass('sizechart--active').css('display', 'flex');
          $('#after_size_input').show();
        },
      });
	});
  $("body").on( 'click','.size-radio-box .ss-input', function(){
        $('#width_n').html($(this).attr('data-width_n'));
        $('#width_r').html($(this).attr('data-width_r'));
        $('#width_w').html($(this).attr('data-width_w'));
	});

  if($('.cnform').length){
    now_or_later_fc_send();
  }else{
    now_or_later_fc();
  }

  $("[name='now_or_later']").on( 'click', function(){
       if($('.cnform').length){
    now_or_later_fc_send();
  }else{
    now_or_later_fc();
  }
  });
    function now_or_later_fc_send()
    {
       if($("[name='sizes_type']").filter(":checked").val()=='customization'){
          if($("[name='now_or_later']").filter(":checked").val()=='now'){
            $('.now-order').show();
            $('.later-order').hide();
             $('.later-input').each(function() {
               $(this).prop('required',false);
             });
              $('.now-input').each(function() {
               $(this).prop('required',true);
             });
             $('.later-input').each(function() {
               $(this).removeAttr('name');
             });
             $('.now-input').each(function() {
               $(this).attr('name',$(this).attr('data-name'));
             });
          }else{
            $('.now-order').hide();
            $('.later-order').show();
              $('.now-input').each(function() {
               $(this).prop('required',false);
             });
              $('.later-input').each(function() {
               $(this).prop('required',true);
             });
             $('.now-input').each(function() {
               $(this).removeAttr('name');
             });
             $('.later-input').each(function() {
               $(this).attr('name',$(this).attr('data-name'));
             });
          }
      }
    }

  function now_or_later_fc()
    {
       if($("[name='sizes_type']").filter(":checked").val()=='customization'){
          if($("[name='now_or_later']").filter(":checked").val()=='now'){
            $('.now-order').show();
            $('.later-order').hide();
            $('.new_profile').hide();
            $('.new_profile').prop('required',false);
            $('#size_id').attr('name',$('#size_id').attr('data-name'));
            $('.cart-size').attr('name',$('.cart-size').attr('data-name'));
            $('.have-size-code').attr('name','');
            $('.have-size-code').prop('required',false);
            var cust_id=$('#foot_custid').val();
            if(typeof cust_id !== "undefined" && cust_id != ''){
              $('.cart-size').show();
            }
          }else{
            $('.now-order').hide();
            $('.later-order').show();
            $('.new_profile').show();
            $('.new_profile').prop('required',true);
            $('#size_id').attr('name','');
            $('.cart-size').attr('name','');
            $('.cart-size').hide();
            $('.have-size-code').attr('name',$('.have-size-code').attr('data-name'));
            $('.have-size-code').prop('required',true);
          }
      }
    }

   $(".have-size-code").on( 'keyup keypress blur change', function(){
        var vid=$(".product__atc [name='id']").val();
        var size=normalizeBiopodsCode($(".have-size-code").val());
        if(typeof vid !== "undefined" && vid !== ''){
          var sku=$('#v_sku').find("option[value='" +vid+ "']").text();
          console.log(sku+' - '+size);
          $('#ss_master_sku').val(sku+'-'+size);
        }
        setMatchedShoeSizeFields(getBiopodsShoeSizeLabel(size));
        if(size.indexOf("-") < 0)
        {
          $('.later-error').show();
        }else{
          $('.later-error').hide();
        }
  });
 $("#add_me_now").on( 'click', function(){
     $('#addfm').bmodal('show');
  });

  $('.ss-input').change(function() {
   $('#ss_size_code').val(getSelectedStandardShoeSizeLabel());
    $('#size_id').val('');
  });

 $(".shoes-form").on( 'submit', function(event){
    $("[name='properties[Sizes Type]']").val($("[name='sizes_type']").filter(":checked").val());
      if($("[name='sizes_type']").filter(":checked").val()=='standard'){
        if($('#size_id').val()==''){
          event.preventDefault();
          var formdata = $(this).serialize();
          var product__title=$('.product__title').text();
          var color=$('.swatch--color.swatch--active').attr('data-swatch-option');
          var vid=$(".product__atc [name='id']").val();
        var sku=$('#v_sku').find("option[value='" +vid+ "']").text();
      formdata=formdata+'&title='+product__title+'&color='+color+'&name='+$("[name='properties[These shoes are for]']").val()+'&sku='+sku;
     $('body').append('<div class="wait"></div>');
            $.ajax({
              type: 'POST',
              url: app_url_feet + "shoe_cals/ss_shoes_form",
              data: formdata,
              dataType: "json",
              success: function (data) {
                 $('.wait').remove();
                 if( data.success ){
					if( data.sku_data ){
						if( data.sku_data.size_found ){
                            $('#size_id').val(data.sku_data.size_id);
                            $('#ss_size_code').val(getSelectedStandardShoeSizeLabel());
                            $('#ss_master_sku').val(data.sku_data.master_sku);
                            $(".shoes-form").submit();
                          }
                    }
                   }
              }
            });
        }else{
          event.preventDefault();
          new_product_add_to_cart('standard');
        }
      }else if($("[name='sizes_type']").filter(":checked").val()=='customization'){
         if($("[name='now_or_later']").filter(":checked").val()=='now'){
          if($('.cart-size').val() == 'New Size code')
          {
            event.preventDefault();
            $('.now-error').show();
          }else{
            $('.now-error').hide();
            new_product_add_to_cart('now');
          }
          event.preventDefault();
        }else{
           $('.now-error').hide();
           var size=$(".have-size-code").val();
            if(size.indexOf("-") < 0)
            {
              $('.later-error').show();
              event.preventDefault();
            }else{
              $('.later-error').hide();
              new_product_add_to_cart('later');
            }
            event.preventDefault();
        }
      }else{
        event.preventDefault();
      }
  });
  function new_product_add_to_cart(form)
    {
        var vid=$(".product__atc [name='id']").val();
        var pid=$('#v_sku').attr('data-pid');
      if(form!='standard'){
        $('.cart-size').trigger('change');
      }
      var sku=$("[name='properties[Master SKU]']").val();
       $('body').append('<div class="wait"></div>');
        $.ajax({
              type: 'POST',
              url: app_url_feet + "shoe_cals/new_product_add_to_cart",
              data:{vid:vid,pid:pid,sku:sku},
              success: function (data) {
                   properties = {};
                   var matchedShoeSize = $('#ss_size_code').val();
                   properties['These shoes are for'] = $("[name='properties[These shoes are for]']").val();
                   properties['Sizes Type'] = $("[name='properties[Sizes Type]']").val();
                   if(form=='standard'){
                       var g=$("[name='std_gender']:checked").val();
                      var s=$("[name='std_size']:checked").val();
                     if(g == 'man'){
                       properties['Size'] = "US Men's " + s ;
                     }
                     if(g == 'woman'){
                       properties['Size'] = "US Women's " + s ;
                     }
                     if(g == 'child'){
                       properties['Size'] = "US Children's " + s ;
                     }
                     properties['_Product_Size_ID'] = $("[name='properties[_Product_Size_ID]']").val();
                   }
                if(form=='now'){
                    properties['_size_code'] = $("[name='properties[_size_code]']").val();
                    if(matchedShoeSize != ''){
                      properties['Size'] = matchedShoeSize;
                    }
                    properties['_Product_Size_ID'] = $("[name='properties[_Product_Size_ID]']").val();
                   }
                if(form=='later'){
                    if(matchedShoeSize != ''){
                      properties['Size'] = matchedShoeSize;
                    }
                    properties['_size_code'] = $("[name='properties[_size_code]']").val();
                   }
                    $.ajax({
                      type: 'POST',
                      url: '/cart/add.js',
                      data: {
                        quantity: 1,
                        id: data,
                        properties:properties
                      },
                       dataType: 'json',
                       success: function (data) {
                        $('.wait').remove();
                         location.href="/cart";
                       }
                    });
              }
            });
    }
  function generate_code(){
    if($("[name='std_unit']").filter(":checked").val() === undefined){ return; }
    if($("[name='std_size']").filter(":checked").val() === undefined){ return; }
    if($("[name='std_width']").filter(":checked").val() === undefined){ return; }
    if($("[name='std_volume']").filter(":checked").val() === undefined){ return; }
    if($("[name='std_arch']").filter(":checked").val() === undefined){ return; }
       var formdata = $(".shoes-form").serialize();
         var product__title=$('.product__title').text();
     var color=$('.swatch--color.swatch--active').attr('data-swatch-option');
 var vid=$(".product__atc [name='id']").val();
        var sku=$('#v_sku').find("option[value='" +vid+ "']").text();
      formdata=formdata+'&title='+product__title+'&color='+color+'&name='+$("[name='properties[These shoes are for]']").val()+'&store_db=no&sku='+sku;
     $('body').append('<div class="wait"></div>');
            $.ajax({
              type: 'POST',
              url: app_url_feet + "shoe_cals/ss_shoes_form",
              data: formdata,
              dataType: "json",
              success: function (data) {
                 $('.wait').remove();
                 if( data.success ){
					if( data.sku_data ){
						if( data.sku_data.size_found ){
                          $('#ss_name').html($('#ss_name').html() + '= Your size Code: '+data.sku_data.sku);
                          }
                    }
                   }
              }
            });
  }
$('body').on( 'change','.ss-input', function(e){
  ss_name();
});
$(".swatch--color").on( 'click', function(){
  ss_name();
});
  function ss_name(){
    var product__title=$('.product__title').text();
    var color=$('.swatch--color.swatch--active').attr('data-swatch-option');
    var size=$("[name='std_size']").filter(":checked").val();
    var width=$("[name='std_width']").filter(":checked").val();
    var volume=$("[name='std_volume']").filter(":checked").val();
    var arch=$("[name='std_arch']").filter(":checked").attr('data-value');
    var ss_name=product__title;
    if(color != undefined){ ss_name=ss_name+ ' / ' + color; }
    if(size != undefined){ ss_name=ss_name+ ' / Size: ' + size; }
    $('#ss_name').html(ss_name);
    generate_code();
    voulme_range();
  }
  function voulme_range(){
    var g=$("[name='std_gender']:checked").val();
    var s=$("[name='std_size']:checked").val();
    var w=$("[name='std_width']:checked").val();
    if(g!= undefined && s != undefined && w!= undefined){
		$.ajax({
        type: 'POST',
        url: app_url_feet + "shoe_cals/voulme_range",
        dataType:'json',
        data:{gender:g,std_size:s,std_width:w},
        success: function (data) {
        $('#voulme_thin').html(data.voulme_thin);
         $('#voulme_regular').html(data.voulme_regular);
          $('#voulme_thick').html(data.voulme_thick);
        },
      });
    }
  }

  $("#hp_signup").on( 'submit', function(event){
    event.preventDefault();
    var password=$("[name='contact[6-password]']").val();
    var confirm_password=$("[name='contact[7-confirm-password]']").val();
    $('#hp_signup .form_message').html('');
    $('#hp_signup .form_message').css('color','');
    if(password.length < 6){
       $('#hp_signup .form_message').html('Password required minimum 6 characters length.');
      $('#hp_signup .form_message').css('color','red');
      return;
    }
    if(password!=confirm_password){
      $('#hp_signup .form_message').html('Password & Confirm Password not same.');
      $('#hp_signup .form_message').css('color','red');
      return;
    }
    var formdata = $(this).serialize();
     $('#hp_signup').append('<div class="wait"></div>');
            $.ajax({
              type: 'POST',
              url: app_url_feet + "shoe_cals/hp_signup",
              data: formdata,
              dataType: "json",
              success: function (data) {
                 $('.wait').remove();
                 if( data.success ){
					$('#hp_signup .form_message').html(data.message);
                    $('#hp_signup .form_message').css('color','green');
                   $("#hp_signup").trigger('reset');
                   }else{
                    $('#hp_signup .form_message').html(data.message);
                    $('#hp_signup .form_message').css('color','red');
                   }
              }
            });
 });
    $('.ws_profile').each(function() {
   var   cust_id=$(this).attr('data-cid');
      var $this=$(this);
       $.ajax({
            type: 'POST',
            url: app_url_feet + "shoe_cals/get_foot_option_wh",
            dataType: "json",
            data: {
              cust_id:cust_id,
            },
            success: function (data) {
              if(data.html!=''){
                $this.html('<option value="" >Select Custom Size Code</option>'+data.html);
                 $this.show();
              }else{
                $this.hide();
              }
                $this.select2();
            },
            });
      });
     $('.ws_size').each(function() {
         var cust_id=$(this).attr('data-cid');
          var $this=$(this);
       $.ajax({
            type: 'POST',
            url: app_url_feet + "shoe_cals/get_size_w",
            dataType: "json",
            data: {
              cust_id:cust_id,
            },
            success: function (data) {
              if(data.html!=''){
                $this.html('<option value="" >Select Standard Size</option>'+data.html);
                 $this.show();
              }else{
                $this.hide();
              }
                $this.select2();
            },
            });
      });

$('body').on( 'change','.ws_profile', function(e){
          var   pid=$(this).attr('data-pid');
         var name=$(this).find('option:selected').attr('data-name');
         $('#shoe_for_'+pid).val(name);
          $('#type_'+pid).val('customization');
           var parent=$(this).parent('.shop-listings-size');
          if($(this).val()!=''){
            parent.find('.ws_size').val('');
            parent.find(".ws_size").select2("destroy").select2();
            parent.find('.std-size').val('');
            parent.find('.std-size').attr('name','');
            parent.find('.ws_profile').attr('name',parent.find('.ws_profile').attr('data-name'));
            parent.find('.ws_size').prop('required',false);
          }else{
            parent.find('.std-size').attr('name',parent.find('.std-size').attr('data-name'));
            parent.find('.ws_size').prop('required',true);
            parent.find('.ws_profile').attr('name','');
          }
        });

  $('body').on( 'change','.ws_size', function(e){
        var   pid=$(this).attr('data-pid');
        var name=$(this).attr('data-cname');
        $('#shoe_for_'+pid).val(name);
        $('#type_'+pid).val('standard');
        var parent=$(this).parent('.shop-listings-size');
        if($(this).val()!=''){
          parent.find('.ws_profile').val('');
          parent.find(".ws_profile").select2("destroy").select2();
          parent.find('.ws_profile').attr('name','');
          parent.find('.ws_profile').prop('required',false);
          $('body').append('<div class="wait"></div>');
          $.ajax({
            type: 'POST',
            url: app_url_feet + "shoe_cals/ss_shoes_form_w",
            data:{ size:$(this).val() },
            success: function (data) {
              parent.find('.std-size').val(data);
              parent.find('.std-size').attr('name',parent.find('.std-size').attr('data-name'));
              $('.wait').remove();
            },
          });
      }else{
        parent.find('.ws_profile').attr('name',parent.find('.ws_profile').attr('data-name'));
        parent.find('.ws_profile').prop('required',true);
        parent.find('.std-size').attr('name','');
      }
  });
  $('body').on( 'submit','#addsize form', function(e){
    var $_form = $(this);
        e.preventDefault();
        $('#addsize').append('<div class="wait"></div>');
      $( '.form-notifications-container' ).html('');
     var size=$(".have-size-code").val();
            if(size.indexOf("-") < 0)
            {
              $( '.form-notifications-container' ).html("<div class='error'>Invalid Size Code</div>");
              $('.wait').remove();
               return;
            }
        var formdata = $_form.serialize();
            $.ajax({
              type: 'POST',
              url: app_url_feet + "shoe_cals/add_size_code_w",
              data: formdata,
              dataType: "json",
              success: function (data) {
                $('.wait').remove();
			    if( data.success ){
                   $("#addsize [name='name']").val('');
                   $("[name='gender']").prop('checked', false);
                   $("#addsize [name='size']").val('');
                   $( '.form-notifications-container' ).html( "Size code added successfully." );
                  get_foot_list();
				}
              },
              });
     });
    $(document).on("submit", ".shop-listings .shopify-product-form", function(e) {
      e.preventDefault();
      if($(this).find('.ws_profile').length > 0){
        var vid=$(this).find("[name='id']").val();
        var pid=$(this).find('.product_id').val();
        var sku=$(this).find("[name='id'] option:selected").attr('data-sku');
        var form=$('#type_'+pid).val();
         if(form=='standard'){
           sku=sku+ '-' + $(this).find('.std-size').val();
         }else{
           sku=sku+ '-' + $(this).find('.ws_profile option:selected').val();
         }
        var $this=$(this);
       $('body').append('<div class="wait"></div>');
        $.ajax({
              type: 'POST',
              url: app_url_feet + "shoe_cals/new_product_add_to_cart",
              data:{vid:vid,pid:pid,sku:sku},
              success: function (data) {
                   properties = {};
                   properties['These shoes are for'] = $('#shoe_for_'+pid).val();
                   properties['Sizes Type'] = form;
                   if(form=='standard'){
                      var s=$this.find('.ws_size').val();
                     if(s.indexOf('M') != -1){ properties['Size'] = "US Men's " + s; }
                     if(s.indexOf('L') != -1){ properties['Size'] = "US Women's " + s; }
                     if(s.indexOf('C') != -1){ properties['Size'] = "US Children's " + s; }
                   }else{
                     properties['_size_code'] = $this.find('.ws_profile option:selected').val();
                    properties['_Product_Size_ID'] = $this.find('.ws_profile option:selected').attr('data-id');
                   }
                     console.log(properties);
                    $.ajax({
                      type: 'POST',
                      url: '/cart/add.js',
                      data: { quantity: 1, id: data, properties:properties },
                       dataType: 'json',
                       success: function (data) {
                          $('.wait').remove();
                          $('.cart-message').hide();
                          $('.cart-message').html('');
                          $this.find('.cart-message').html('Item added to cart!');
                          $this.find('.cart-message').show();
                       }
                    });
              }
            });
      }else{
          $('body').append('<div class="wait">&nbsp;</div>');
          var a = new FormData($(this)[0]);
          var $this=$(this);
            $.ajax({
                    url: "/cart/add.js",
                    data: a,
                    type: "POST",
                    dataType: "JSON",
                    contentType: false,
                    processData: false,
                    cache: false,
                    success: function(f) {
                      $('.wait').remove();
                      $('.cart-message').hide();
                      $('.cart-message').html('');
                      $this.find('.cart-message').html('Item added to cart!');
                      $this.find('.cart-message').show();
                    },
            		error : function(error){
                      $('.wait').remove();
                      alert(error.responseJSON.description);
                    },
            });
      }
    });

   $("#button--7fb576f3-53e6-4e46-a9c2-d753a6a1e72f").on( 'click', function(){
     $('#addfm').bmodal('show');
     $('#store_db').val('no');
  });

document.addEventListener('booster:cart:update', (e)=>{
  setTimeout(function() {get_foot_option_cart();}, 1000);
});
   $('.sizechart').removeClass('sizechart--active').hide();

  // Use addClass/removeClass with the stylesheet's !important CSS rule
  // instead of jQuery .hide()/.show() which the Booster theme overrides in Chrome.
  $('body').on( 'change','.std-gender', function(e){
    $('.ssize').addClass('ssize-hidden');
    $('.sizeof_'+$(this).val()).removeClass('ssize-hidden');
    $('.swatches_boxs_Size').show();
    $('.sizechart').removeClass('sizechart--active').hide();
    var g = $(this).val();
    if(g=='men'){ g='man'; }
    if(g=='women'){ g='woman'; }
    $('#'+g+'_chart').addClass('sizechart--active').css('display', 'flex');
  });

$('body').on( 'submit','.cnform', function(e){
   var $_form = $(this);
        e.preventDefault();
        $('#addfm').append('<div class="wait"></div>');
    $( '.cnform-mes' ).html('');
        var formdata = $_form.serialize();
   $.ajax({
              type: 'POST',
              url: app_url_feet + "shoe_cals/cnform",
              data: formdata,
              dataType: "json",
              success: function (data) {
                 $('.now-input').each(function() {
                   if($(this).attr('type')== 'text' || $(this).attr('type')== 'email' || $(this).attr('type')== 'number' ){
                     $(this).val('');
                   }
             });
              $('.later-input').each(function() {
                 if($(this).attr('type')== 'text' || $(this).attr('type')== 'email' || $(this).attr('type')== 'number' ){
                     $(this).val('');
                   }
             });
                $( '.cnform-mes' ).html('Your information was successfully sent. Thank you. We will follow up with you by return email shortly.');
              }
     });
  });

});
